import React from 'react'
import Modal from '@components/common/modal'
import { Trans } from '@lingui/macro'
import { Play, X } from 'react-feather'
import { FastlyImage } from '@components/common/image'
import { CurriculumVideoType } from '@components/locale-pages/home/courses'

type Props = {
  isModalOpen: boolean
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  curriculumVideo: CurriculumVideoType[]
  courseTitle: string
}

const CourseVideoModal = ({
  isModalOpen,
  setIsModalOpen,
  curriculumVideo,
  courseTitle,
}: Props) => {
  const [videoModalOpen, setVideoModalOpen] = React.useState<boolean>(false)
  const [videoURL, setVideoURL] = React.useState<string>('dd')

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        width="w-full lg:max-w-3xl"
      >
        <div className="py-2">
          <button
            className="absolute top-0 right-0 mt-3 mr-3 text-lg cursor-pointer text-grey-800 font-700"
            onClick={() => setIsModalOpen(false)}
          >
            <X className="stroke-2 text-grey-800" />
          </button>
          <div className="flex flex-col space-y-10 text-center">
            <h3 className="text-2xl font-600 text-grey leading-tight">
              <Trans>Watch {courseTitle} course intro by grade</Trans>
            </h3>
            <div className="flex justify-center gap-3 space-between flex-wrap">
              {curriculumVideo.map((video) => (
                <button
                  key={video.altText}
                  className="flex flex-col items-center"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setIsModalOpen(false)
                    setVideoURL(video.url)
                    setVideoModalOpen(true)
                  }}
                >
                  <div className="relative">
                    <FastlyImage
                      src={`/images/courses/video-thumbnail/${video.image}.jpg`}
                      alt={video.altText}
                      width={301}
                      height={168}
                      className="mb-2"
                    />
                    <button className="absolute w-full h-full z-20 bottom-0 flex group focus:outline-none">
                      <span className="p-3 bg-white bg-opacity-50 m-auto rounded-full group-hover:shadow-lg group-hover:bg-orange">
                        <Play size={16} fill="#000" />
                      </span>
                    </button>
                  </div>
                  <span className="text-base lg:text-xl">
                    <Trans>Grade</Trans> {video.grades}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={videoModalOpen}
        setIsOpen={setVideoModalOpen}
        isCrossIconShown={true}
        shouldCloseOnEsc
        width="mt-12 sm:mt-5"
        className="bg-black pl-0 pr-0"
      >
        <div>
          <iframe
            src={videoURL}
            className="-my-5 sm:-my-10 rounded-lg w-full h-80 sm:h-screen"
            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
            allowFullScreen
          />
        </div>
      </Modal>
    </>
  )
}

export default CourseVideoModal
